import 'css-chunksrc/client/scenes/addPlanzoneResourceToProjects/projectsSelection/zones/styles.scss';export default {
  "header": "_header_17hqw_1",
  "title": "_title_17hqw_10",
  "loader": "_loader_17hqw_17"
};